import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    return data.error || data.detail || data.message || fallback;
};
const normalizeStatus = (status) => {
    const value = String(status !== null && status !== void 0 ? status : "").trim().toLowerCase();
    if (["success", "completed", "done"].includes(value))
        return "done";
    if (["pending", "received", "queued"].includes(value))
        return "queued";
    if (["started", "processing", "retry", "running"].includes(value))
        return "running";
    if (["failure", "failed", "error", "timeout", "cancelled", "canceled"].includes(value))
        return "failed";
    return value;
};
export async function runContentModeration(params) {
    var _a, _b, _c;
    const normalizedUserId = String((_a = params.payload.user_id) !== null && _a !== void 0 ? _a : "").trim();
    const body = {
        ...(normalizedUserId ? { user_id: normalizedUserId } : {}),
        include_public: (_b = params.payload.include_public) !== null && _b !== void 0 ? _b : false,
        async: (_c = params.payload.async) !== null && _c !== void 0 ? _c : true
    };
    const data = await apiFetch(`/user/api/admin/content-moderation/run/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        waitForBackgroundTask: false,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to run content moderation"));
    }
    return { ...data, status: normalizeStatus(data === null || data === void 0 ? void 0 : data.status) || ((data === null || data === void 0 ? void 0 : data.task_id) ? "queued" : "") };
}
export async function getContentModerationRunStatus(params) {
    const data = await apiFetch(`/user/api/admin/content-moderation/run/${encodeURIComponent(params.taskId)}/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
        waitForBackgroundTask: false,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to fetch moderation status"));
    }
    return { ...data, status: normalizeStatus(data === null || data === void 0 ? void 0 : data.status) };
}
